/**
 * Deadline countdown pill. Renders nothing when the workflow is
 * completed (the deadline has stopped mattering) or the item has no
 * deadline_date yet.
 */
import { Clock } from "@phosphor-icons/react";

export default function DeadlinePill({ deadline, status }) {
  if (!deadline || status === "completed") return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(deadline);
  due.setHours(0, 0, 0, 0);
  const days = Math.round((due - today) / 86400000);
  const overdue = days < 0;
  const soon = days >= 0 && days <= 3;
  const cls = overdue
    ? "bg-rose-600 text-white"
    : soon
    ? "bg-amber-500 text-white"
    : "bg-slate-200 text-slate-700";
  const txt = overdue
    ? `${Math.abs(days)}d overdue`
    : days === 0
    ? "Due today"
    : `${days}d left`;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold ${cls}`}
      data-testid="pc-deadline-pill"
      title={`Deadline: ${due.toLocaleDateString("en-GB")}`}
    >
      <Clock weight="bold" className="w-3 h-3" />
      {txt}
    </span>
  );
}
